import router from "@/router";

// Import the plugin here
import { Auth0Plugin } from "./index";

// Import the Auth0 configuration
const { domain, clientId, audience } = window.__env.auth0_config;

export default (app) => {
  console.log(Auth0Plugin,111);
  
  // Use the plugin in Vue 3
  app.use(
    Auth0Plugin, // Ensure Auth0Plugin is compatible with Vue 3
    {
      domain,
      clientId,
      audience,
      onRedirectCallback: appState => {
        console.log(appState,1200);
        
        router.push(
          appState && appState.targetUrl
            ? appState.targetUrl
            : window.location.pathname
        );
      }
    }
  );
};
